// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1Xyop","title":"ClientReferral_title__w5_PQ","itemText":"ClientReferral_itemText__1APIx"};